<script lang="ts">
	import ProfileReviewCard from '$lib/components/profile/ProfileReviewCard.svelte';
	import { m } from '$lib/paraglide/messages.js';
	import type { FeaturedReview } from '@/routes/barcos/[...segments]/+page';
	import { getLocale } from '@/paraglide/runtime';

	interface Props {
		title: string;
		subtitle: string;
		reviews: FeaturedReview[];
	}

	let { title, subtitle, reviews }: Props = $props();

	const locale = $derived(getLocale());
	const instagramReviews = $derived.by(() => {
		void locale;
		return [
			{
				alt: m.landing_instagram_review_patricia_alt(),
				href: 'https://www.instagram.com/p/DaJDkfMjcV1/'
			},
			{
				alt: m.landing_instagram_review_cies_recommendation_alt(),
				href: 'https://www.instagram.com/carla_dipinto/'
			},
			{
				alt: m.landing_instagram_review_cies_location_alt(),
				href: 'https://www.instagram.com/carla_dipinto/'
			},
			{
				alt: m.landing_instagram_review_collage_alt(),
				href: 'https://www.instagram.com/p/DaVIOFAAtw3/?img_index=7'
			}
		] as const;
	});
</script>

{#if reviews.length > 0}
	<section aria-labelledby="marketplace-reviews-heading" class="space-y-6">
		<div class="space-y-2">
			<h2 id="marketplace-reviews-heading" class="text-xl font-semibold tracking-tight md:text-2xl">
				{title}
			</h2>
			<p class="text-muted-foreground text-sm md:text-base">{subtitle}</p>
		</div>

		<div class="mx-auto grid max-w-sm grid-cols-2 gap-3 sm:max-w-2xl sm:gap-4">
			<figure
				class="overflow-hidden rounded-xl border bg-card outline-1 -outline-offset-1 outline-black/5 transition-shadow hover:shadow-sm"
			>
				<a
					href={instagramReviews[0].href}
					target="_blank"
					rel="noopener"
					class="block"
					aria-label={instagramReviews[0].alt}
				>
					<enhanced:img
						src="/static/img/landing/instagram-review-zarpar-motora.png"
						alt={instagramReviews[0].alt}
						loading="lazy"
						sizes="(min-width: 640px) 200px, min(45vw - 1rem, 200px)"
						class="block w-full"
					></enhanced:img>
				</a>
			</figure>
			<figure
				class="overflow-hidden rounded-xl border bg-card outline-1 -outline-offset-1 outline-black/5 transition-shadow hover:shadow-sm"
			>
				<a
					href={instagramReviews[1].href}
					target="_blank"
					rel="noopener"
					class="block"
					aria-label={instagramReviews[1].alt}
				>
					<enhanced:img
						src="/static/img/landing/zarpar-review-instagram-cies.png"
						alt={instagramReviews[1].alt}
						loading="lazy"
						sizes="(min-width: 640px) 200px, min(45vw - 1rem, 200px)"
						class="block w-full"
					></enhanced:img>
				</a>
			</figure>
			<figure
				class="overflow-hidden rounded-xl border bg-card outline-1 -outline-offset-1 outline-black/5 transition-shadow hover:shadow-sm"
			>
				<a
					href={instagramReviews[2].href}
					target="_blank"
					rel="noopener"
					class="block"
					aria-label={instagramReviews[2].alt}
				>
					<enhanced:img
						src="/static/img/landing/zarpar-review-cies.png"
						alt={instagramReviews[2].alt}
						loading="lazy"
						sizes="(min-width: 640px) 200px, min(45vw - 1rem, 200px)"
						class="block w-full"
					></enhanced:img>
				</a>
			</figure>
			<figure
				class="overflow-hidden rounded-xl border bg-card outline-1 -outline-offset-1 outline-black/5 transition-shadow hover:shadow-sm"
			>
				<a
					href={instagramReviews[3].href}
					target="_blank"
					rel="noopener"
					class="block"
					aria-label={instagramReviews[3].alt}
				>
					<enhanced:img
						src="/static/img/landing/instagram-review-zarpar.png"
						alt={instagramReviews[3].alt}
						loading="lazy"
						sizes="(min-width: 640px) 200px, min(45vw - 1rem, 200px)"
						class="block w-full"
					></enhanced:img>
				</a>
			</figure>
		</div>

		<div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
			{#each reviews as review (review.id)}
				<div class="rounded-xl border bg-card p-4 md:p-5">
					<ProfileReviewCard review={review} compact />
				</div>
			{/each}
		</div>
	</section>
{/if}
